import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersist from 'vuex-persist'
import locations from './modules/locations'
import settings from './modules/settings'

Vue.use(Vuex)

const vuexPersist = new VuexPersist({
  key: 'app-storage',
  storage: window.localStorage,
  
  reducer: (state) => ({
    settings:{
      app_logged_in:state.settings.app_logged_in,
      app_locale:state.settings.app_locale
    }
  })
  /* settings:state.settings */
})

export default new Vuex.Store({
  namespaced: true,
  modules: {
    locations,
    settings
  },
  plugins: [vuexPersist.plugin]
})
